import { RouterView } from "vue-router";
import { WorkPackageRouting } from "./workPackage/workPackage.routing";
import { WorkOrderRouting } from "./workOrder/workOrder.routing";
import { ServiceClassificationRouting } from "./serviceClassification/service-classification.routing";



export const MaintenanceSettingRouting = {
  path: "/maintenanceSetting",
  name: "maintenanceSetting",
  redirect: "/maintenanceSetting/workPackage",
  component: RouterView,
  meta: { title: "维保管理", icon: "cailiao" },
  children: [
    ...WorkPackageRouting,
    ...WorkOrderRouting,
    ...ServiceClassificationRouting
  ],
};
